import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import { default as Box, default as TableRow } from '@mui/material/TableRow';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import Title from '/@/v3/components/title';

const FileTable = ({ files, onDelete = false, hideHeaders = false }) => {
    return (
        <Table sx={{ minWidth: { xs: 0, md: 650 } }} aria-label='simple table'>
            <TableHead>
                <TableRow>
                    <TableCell>
                        {!hideHeaders && (
                            <Title bolder size='sm' theme={settings.app.theme}>
                                {_('Nombre')}
                            </Title>
                        )}
                    </TableCell>
                    <TableCell>
                        {!hideHeaders && (
                            <Title bolder size='sm' theme={settings.app.theme}>
                                {_('Extensión')}
                            </Title>
                        )}
                    </TableCell>
                    <TableCell sx={{ display: { xs: 'none', md: 'block' } }}>
                        <Title bolder size='sm' theme={settings.app.theme}>
                            {_('Peso')}
                        </Title>
                    </TableCell>
                    {onDelete && <TableCell />}
                </TableRow>
            </TableHead>
            <TableBody className='mp-mask'>
                {Array.from(files).map((file) => (
                    <TableRow key={file.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component='th' scope='row' sx={{ wordBreak: 'break-all' }}>
                            {file.name}
                        </TableCell>
                        <TableCell>{file.name.split('.').pop()}</TableCell>
                        <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>
                            {file.size ? Math.round(file.size / 1024) : ' - '}kB
                        </TableCell>
                        {onDelete && (
                            <TableCell sx={{ textAlign: 'end' }}>
                                <Button
                                    variant='text'
                                    onClick={() => onDelete(file)}
                                    color='primary'
                                    endIcon={<DeleteOutlineIcon />}
                                >
                                    <Box sx={{ display: { xs: 'none', md: 'block' } }}>{_('Eliminar')}</Box>
                                </Button>
                            </TableCell>
                        )}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default FileTable;
